import { render, staticRenderFns } from "./WebsiteOrderExpressList.vue?vue&type=template&id=0be08564&scoped=true&"
import script from "./WebsiteOrderExpressList.vue?vue&type=script&lang=js&"
export * from "./WebsiteOrderExpressList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be08564",
  null
  
)

export default component.exports